import { Links } from '@/config/app'
import { useQuery } from '@tanstack/react-query'
import { useZAFClient } from '@/features/zendesk-app'

export const useGuideUrl = (): string => {
  const zafClient = useZAFClient()

  const { data: link } = useQuery({
    queryKey: ['zendesk-app'],
    queryFn: async () => {
      if (!zafClient) return
      const { settings } = await zafClient.metadata()
      return settings.guideUrl as string
    },
    staleTime: Infinity,
  })

  return link ?? Links.deployToZendeskArticle
}
